module.exports = __webpack_public_path__ + "static/media/menu-card-3.249a157c.jpg";